export default __webpack_public_path__ + "assets/togo-flag.png";